var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardPanel',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 col-xl-3"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("title-column")],2),_c('div',{staticClass:"col-12 col-md-8 col-xl-9"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }